(() => {
  'use strict';

  const MAX_ATTEMPTS = 16;
  const RETRY_MS = 250;

  const isProductPage = () =>
    document.body.classList.contains('template-product') ||
    Boolean(document.querySelector('[data-product-single-media-group]'));

  const needsGalleryInit = () => {
    const wrappers = document.querySelectorAll(
      '[data-product-single-media-flex-wrapper]',
    );
    if (wrappers.length < 2) {
      return false;
    }

    const main = document.querySelector(
      '.product-single__media-group.slick:not(.slick-initialized)',
    );
    const thumbs = document.querySelector(
      '.product-single__thumbnails.slick:not(.slick-initialized)',
    );
    return Boolean(main || thumbs);
  };

  const initGallery = () => {
    const $ = window.jQuery;
    const theme = window.theme;
    if (!$ || !theme || !theme.carousel || !theme.variables) {
      return false;
    }

    const $media = $('.product-single__media-group.slick').not(
      '.slick-initialized',
    );
    const $thumbs = $('.product-single__thumbnails.slick').not(
      '.slick-initialized',
    );

    if (!$media.length && !$thumbs.length) {
      return true;
    }

    const speed = theme.variables.transitionSpeed || 300;
    const thumbOptions = {
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      focusOnSelect: true,
      asNavFor: $media,
      swipeToSlide: true,
      infinite: false,
      speed,
    };
    const mediaOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      fade: $media.is('[data-carousel-fade-effect]'),
      arrows: true,
      focusOnSelect: false,
      asNavFor: $thumbs,
      infinite: false,
      speed,
      adaptiveHeight: true,
    };

    const goToSlide = Math.max(
      0,
      $('.product-single__media-flex-wrapper.is-featured-media').index(),
    );

    if (
      $thumbs.length &&
      $('.product-thumbnail-wrapper', $thumbs).length >= 2
    ) {
      theme.carousel.init({ slider: $thumbs, slickOptions: thumbOptions });
    }

    if ($media.length) {
      theme.carousel.init({
        slider: $media,
        slickOptions: mediaOptions,
        goToSlide,
      });
    }

    return !needsGalleryInit();
  };

  const scheduleAttempts = (attempt = 0) => {
    if (!isProductPage()) {
      return;
    }

    if (!needsGalleryInit()) {
      return;
    }

    if (initGallery()) {
      return;
    }

    if (attempt + 1 >= MAX_ATTEMPTS) {
      return;
    }

    window.setTimeout(() => scheduleAttempts(attempt + 1), RETRY_MS);
  };

  const boot = () => scheduleAttempts(0);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (
      event.target &&
      event.target.querySelector &&
      event.target.querySelector('[data-product-single-media-group]')
    ) {
      scheduleAttempts(0);
    }
  });
})();
